import { MapTo } from '@adobe/aem-react-editable-components';
import GoogleSearchResults, { GoogleSearchResultsEditConfig } from './GoogleSearchResults';

export default MapTo('cob-corp-acquisition/components/creditonebank/google-search-results')(GoogleSearchResults, GoogleSearchResultsEditConfig);
